import { FC } from 'react';
import { Flex, Stack, Tag, Text, useDisclosure } from '@chakra-ui/react';

import {
  Role,
  TreatyDetailsFragment,
  TreatyUserFragment,
} from '../../graphql/generated';
import { UserDetailsModal } from './user-details-modal';

type UserDetailsProps = {
  user: TreatyUserFragment;
  roles: Role[];
  treaties: TreatyDetailsFragment[];
};

export const UserDetails: FC<UserDetailsProps> = ({
  user,
  roles,
  treaties,
}) => {
  const {
    isOpen: isModalOpen,
    onOpen: openModal,
    onClose: closeModal,
  } = useDisclosure();

  return (
    <>
      <Flex
        as="button"
        py={2}
        aria-label={user.name}
        onClick={openModal}
        width="full"
        _hover={{ '& .user-name': { color: 'blue.500' } }}
      >
        <Stack align="flex-start">
          <Text
            className="user-name"
            fontSize="lg"
            fontWeight="medium"
            textDecoration="underline"
            color="blue.600"
          >
            {user.name}
            {user.isBlocked ? (
              <Tag
                marginLeft="4"
                colorScheme="red"
                size="sm"
                data-testid="blocked-user-tag"
              >
                Blocked
              </Tag>
            ) : null}
          </Text>
          <Text color="gray.600">{user.email}</Text>
        </Stack>
      </Flex>

      <UserDetailsModal
        user={user}
        roles={roles}
        treaties={treaties}
        isOpen={isModalOpen}
        onClose={closeModal}
      />
    </>
  );
};
